export const crestFirebaseConfig = {
    apiKey: 'AIzaSyDze0y2QDP8bl_7nv2dzpSaQYklcnGimcw',
    authDomain: 'crest-sel-chat.firebaseapp.com',
    databaseURL: 'https://crest-sel-chat-default-rtdb.firebaseio.com/',
    storageBucket: 'crest-sel-chat.appspot.com',
    projectId: 'crest-sel-chat',
};
